import * as React from "react";
import cx from "classnames";

import { Checkbox } from "@common/components/checkbox";
import { getTestAttributes } from "@common/utils/tests";
import { MODULE_NAME } from "@modules/invite-status/constants/shared";

import "./multiselect-list.styles.scss";
import { Loading } from "@common/components/loading";
import { Flex } from "@common/components/Flex";

type Option = { value: number | string; label: string };

type MultiselectListProps = {
  label: string;
  options: Array<Option>;
  value?: Array<Option["value"]>;
  onChange: (value: Array<Option["value"]>) => void;
  id: string;
  className?: string;
  classes?: {
    multiselectListBox?: string;
  };
};

export const MultiselectList: React.FC<MultiselectListProps> = (props) => {
  const { label, options, onChange, id, value = [], className, classes } = props;

  const handleChange = React.useCallback(
    (option: Option, isSelected: boolean) => {
      if (isSelected) {
        onChange([...value, option.value]);
      } else {
        onChange(value.filter((filterValue) => filterValue !== option.value));
      }
    },
    [onChange, value]
  );

  return (
    <div className={cx("InvitesFilterMultiselectList", className)}>
      <h6 className="InvitesFilterMultiselectList__field__title">{label}</h6>
      <div className={cx("InvitesFilterMultiselectList__box", classes?.multiselectListBox)}>
        {options.length ? (
          <div className="InvitesFilterMultiselectList__options">
            {options.map((option, optionIndex) => (
              <div className="InvitesFilterMultiselectList__option" key={optionIndex}>
                <Checkbox
                  {...getTestAttributes(MODULE_NAME, `${id}-${optionIndex}`, "checkbox")}
                  classes={{
                    label: "InvitesFilterMultiselectList__checkbox__label",
                    input: "InvitesFilterMultiselectList__checkbox__input",
                  }}
                  className="InvitesFilterMultiselectList__checkbox"
                  checked={value.includes(option.value)}
                  onChange={(isSelected: boolean) => handleChange(option, isSelected)}
                  label={option.label}
                />
              </div>
            ))}
          </div>
        ) : (
          <Flex style={{ margin: 20 }} justify="center">
            <Loading size={25} />
          </Flex>
        )}
      </div>
    </div>
  );
};
